import React from 'react';
import ChartBar from '../../../../components/Dashboard/Bar';
import { timeKeepAttendant } from '../../../../models/WorkTimeKeep';
import LcDropDown from '../../../../components/Generic/LcDropDown';
import LcIconLink from '../../../../components/Generic/LcIconLink';
import SideModal from '../../../../components/Layout/SideModal/SideModal';
import { MenuState } from "../../../../store/reducers/menuReducer";
import { RootState } from "../../../../store";
import { useSelector } from "react-redux";

interface Props {
  timeKeepList: timeKeepAttendant;
  timeKeepListTeam: timeKeepAttendant;
  detailed: boolean;
}

const AttendantHours: React.FC<Props> = (props) => {
  const menu = useSelector<RootState, MenuState>(state => state.menu);
  const options = [
    { label: "Horas por atendente", value: 1 },
    { label: "Horas por equipe", value: 2 },
  ];

  const [selectedOption, setSelectedOption] = React.useState(options[0]);
  const [focus, setFocus] = React.useState<boolean>(false);

  const optionHorasAtendente: echarts.EChartsOption = {
    tooltip: {
      show: props.detailed || focus,
      trigger: 'item',
      borderColor: '#fff',
    },
    legend: {
      show: props.detailed || focus
      // data: ['Estimativa original/Tempo restante/Tempo completado']
    },
    grid: {
      containLabel: true,
      top: (props.detailed && !focus) ? 50 : (focus) ? 50 : 15,
      bottom: (props.detailed && !focus) ? 10 : (focus) ? 70 : 25,
      left: (focus) ? 30 : 25,
      right: (focus) ? 30 : 25,
    },
    xAxis: {
      type: 'category',
      data: props.timeKeepList.name,
      axisLabel: {
        show: props.detailed || focus,
        width: '100',
        overflow: 'truncate',
        hideOverlap: true,
        interval: 0,
        // rotate: 0,
        // verticalAlign: 'middle',
        // align: 'center',
      }
    },
    yAxis: { type: 'value' },
    series: [
      {
        name: 'Estimativa original',
        data: props.timeKeepList.original,
        type: 'bar',
        // barWidth: '30%',
        // stack: 'x',
        color: '#118dff',
        label: {
          show: props.detailed || focus,
          // show: true,
          fontSize: "8px",
          fontWeight: "bold",
        },
      },
      {
        name: 'Tempo completado',
        data: props.timeKeepList.completed,
        type: 'bar',
        // barWidth: '30%',
        // stack: 'x',
        color: '#60c75a',
        label: {
          show: props.detailed || focus,
          // show: true,
          fontSize: "8px",
          fontWeight: "bold",
        },
      },
      {
        name: 'Tempo restante',
        data: props.timeKeepList.remaining,
        type: 'bar',
        // barWidth: '30%',
        // stack: 'x',
        color: '#e1c233',
        label: {
          show: props.detailed || focus,
          // show: true,
          fontSize: "8px",
          fontWeight: "bold",
        },
      },
    ],
    dataZoom: [
      {
        type: 'slider',
        show: focus,
        start: 0,
        end: 100,
        fillerColor: "#d1e0e0",
        borderColor: "rgb(0,0,0)",
        borderRadius: 8,
        moveHandleSize: 10,
        handleSize: "35px",
        height: "15px",
        moveHandleStyle: {
          color: "#0066ff",
        },
        textStyle: {
          fontWeight: "bold"
        }
      },
      {
        type: 'inside',
        start: 0,
        end: 100,
        disabled: !focus
      },
    ],
  };

  //Mockup dados por Equipe
  const optionTimeForTeam: echarts.EChartsOption = {
    tooltip: {
      show: props.detailed || focus,
      trigger: 'item',
      borderColor: '#fff',
    },
    legend: {
      show: props.detailed || focus
      // data: ['Estimativa original/Tempo restante/Tempo completado']
    },
    grid: {
      containLabel: true,
      top: (props.detailed || focus) ? 70 : 15,
      // bottom: (props.detailed && !focus) ? -50 : (focus) ? 5 : 15,
      bottom: (props.detailed && !focus) ? 15 : (focus) ? 50 : 15,
      left: (props.detailed || focus) ? 30 : 15,
      right: (props.detailed || focus) ? 30 : 15,
    },
    xAxis: {
      type: 'category',
      data: props.timeKeepListTeam.name,
      axisLabel: {
        show: props.detailed || focus,
        width: '100',
        overflow: 'truncate',
        hideOverlap: true,
        interval: 0,

        // rotate: 45
        // rotate: 0,
        // verticalAlign: 'middle',
        // align: 'center',
      }
    },
    yAxis: { type: 'value' },
    series: [
      {
        name: 'Esperadas',
        data: props.timeKeepListTeam.original,
        type: 'bar',
        // barWidth: '60%',
        // stack: 'x',
        color: '#a1343c',
        label: {
          show: props.detailed || focus,
          // show: true,
          // position: "top",
          fontSize: "8px",
          fontWeight: "bold",
        },
      },
      {
        name: 'Realizadas',
        data: props.timeKeepListTeam.completed,
        type: 'bar',
        // barWidth: '60%',
        // stack: 'x',
        color: '#cccccc',
        label: {
          show: props.detailed || focus,
          // show: true,
          // position: "top",
          fontSize: "8px",
          fontWeight: "bold",
        },
      },
      {
        name: 'Restante',
        data: props.timeKeepListTeam.remaining,
        type: 'bar',
        // barWidth: '60%',
        // stack: 'x',
        color: '#e66c37',
        label: {
          show: props.detailed || focus,
          // show: true,
          // position: "top",
          fontSize: "8px",
          fontWeight: "bold",
        },
      },
    ],

    dataZoom: [
      {
        type: 'slider',
        show: focus,
        start: 0,
        end: 100,
        fillerColor: "#d1e0e0",
        borderColor: "rgb(0,0,0)",
        borderRadius: 8,
        moveHandleSize: 10,
        handleSize: "35px",
        height: "15px",
        moveHandleStyle: {
          color: "#0066ff",
        },
        textStyle: {
          fontWeight: "bold"
        }
      },
      {
        type: 'inside',
        start: 0,
        end: 100,
        disabled: !focus
      },
    ],
  };

  const Dropdown = () => {
    return (
      <div
        className={"dropdownalt"}
        style={{
          paddingLeft: "7px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "40px",
          width: "250px",
          padding: '20px 10px',
          backgroundColor: '#fff',
          marginBottom: (focus) ? "0px" : "5px"
        }}>
        <LcDropDown
          width={"220px"}
          style={{ width: "100%" }}
          element={
            <span className={"select-period"}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontSize: '16px',
                fontWeight: '400'
              }}>
              &nbsp;{options.find((item: any) => item.value === selectedOption.value)?.label}
              <i className={"ppi ppi-chevron-down-alt"} />
            </span>
          }
        >
          {
            options.map((item: any, index: number) => {
              return (
                <span
                  key={index}
                  className="item"
                  onClick={() => setSelectedOption(item)}
                  style={{ fontWeight: (item.value === selectedOption.value) ? "bold" : "normal" }}
                >
                  {item.label}
                </span>
              )
            })
          }
        </LcDropDown>
      </div>
    )
  }

  return (
    <div className={`chartbox ${!props.detailed && "wDash32p"} boxShadowLightBlack`}
      style={{
        width: "100%",
        height: "100%"
      }}>
      <div
        className={"row start"}
        style={{
          paddingLeft: "16px",
          paddingTop: "6px",
          color: "#8B90A3",
          fontSize: "16px",
          display: "flex",
          justifyContent: "space-between"
        }}>
        <Dropdown />
        <LcIconLink
          icon={"ppi ppi-expand"}
          tooltip={"Ampliar"}
          onClick={() => setFocus(true)}
        />
      </div>

      <div className={"w100p"} style={{ height: "100%" }}>
        <div className={"row center"}>
          {/* <div className='font-sm charBox-font'>Horas por atendente</div> */}
        </div>
        <ChartBar
          options={(selectedOption.value === 1) ? optionHorasAtendente : optionTimeForTeam}
          height={!props.detailed ? "100%" : "400px"}
        />
      </div>

      <SideModal
        header={
          <div className={`row start`}>
            <span style={{ marginRight: "50px" }}>{`${options.find((item: any) => item.value === selectedOption.value)?.label} - Foco`}</span>
            <Dropdown />
          </div>
        }
        visible={focus}
        onClose={() => setFocus(false)}
        width={(!menu.toggle) ? "calc(100% - 260px)" : "calc(100% - 5rem)"}
      >
        {
          <div className={`row column`} style={{ height: "100%" }}>
            <div style={{ width: "100%", height: "100%" }}>
              <ChartBar
                options={(selectedOption.value === 1) ? optionHorasAtendente : optionTimeForTeam}
                height={"100%"}
              />
            </div>
          </div>
        }
      </SideModal>
    </div>
  );
};

export default AttendantHours;